import { Component } from '@angular/core';
import { PrivilegedIdentitiesSectionComponent } from '../privileged-identities-section.component';
import { EffectivePolicySettingEnum } from '../../../services/infra/store/model/effectivePolicySetting.model';

@Component({
  selector: 'app-privileged-identities-ai-skill-section',
  templateUrl: '../privileged-identities-section.component.html',
  styleUrls: ['../privileged-identities-section.component.scss'],
})
export class PrivilegedIdentitiesAiSkillComponent extends PrivilegedIdentitiesSectionComponent {
  constructor() {
    super();
    this.title = 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToAiSkill';
    this.description = 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToAiSkillDesc';
    this.effectivePolicySetting = EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesToAiSkill;
    this.formControlName = 'allowedNumOfPrivilegedIdentitiesToAiSkill';
  }
}
